// extracted by mini-css-extract-plugin
export default {"label":"TaskCategory_label__5NucD"};